import {
  Eraser,
  Power,
  PowerOff,
  RotateCw,
  Send,
  Settings,
  Sliders,
  Sparkles,
  Trash2,
  Unlock,
  Zap,
} from 'lucide-react';
import type { CommandDefinition } from './types';

export const COMMAND_GROUPS: { id: CommandDefinition['group']; labelKey: string }[] = [
  { id: 'charging', labelKey: 'deviceControl.groups.charging' },
  { id: 'connector', labelKey: 'deviceControl.groups.connector' },
  { id: 'device', labelKey: 'deviceControl.groups.device' },
  { id: 'config', labelKey: 'deviceControl.groups.config' },
  { id: 'smartCharging', labelKey: 'deviceControl.groups.smartCharging' },
];

export const COMMANDS: CommandDefinition[] = [
  {
    id: 'remote-start',
    group: 'charging',
    icon: <Zap className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.remoteStart.label',
    descriptionKey: 'deviceControl.commands.remoteStart.description',
  },
  {
    id: 'remote-stop',
    group: 'charging',
    icon: <PowerOff className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.remoteStop.label',
    descriptionKey: 'deviceControl.commands.remoteStop.description',
  },
  {
    id: 'unlock-connector',
    group: 'connector',
    icon: <Unlock className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.unlockConnector.label',
    descriptionKey: 'deviceControl.commands.unlockConnector.description',
  },
  {
    id: 'change-availability',
    group: 'connector',
    icon: <Power className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.changeAvailability.label',
    descriptionKey: 'deviceControl.commands.changeAvailability.description',
  },
  {
    id: 'reset',
    group: 'device',
    icon: <RotateCw className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.reset.label',
    descriptionKey: 'deviceControl.commands.reset.description',
  },
  {
    id: 'clear-cache',
    group: 'device',
    icon: <Eraser className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.clearCache.label',
    descriptionKey: 'deviceControl.commands.clearCache.description',
  },
  {
    id: 'trigger-message',
    group: 'device',
    icon: <Send className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.triggerMessage.label',
    descriptionKey: 'deviceControl.commands.triggerMessage.description',
  },
  {
    id: 'get-configuration',
    group: 'config',
    icon: <Settings className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.getConfiguration.label',
    descriptionKey: 'deviceControl.commands.getConfiguration.description',
  },
  {
    id: 'change-configuration',
    group: 'config',
    icon: <Sliders className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.changeConfiguration.label',
    descriptionKey: 'deviceControl.commands.changeConfiguration.description',
  },
  {
    id: 'set-charging-profile',
    group: 'smartCharging',
    icon: <Sparkles className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.setChargingProfile.label',
    descriptionKey: 'deviceControl.commands.setChargingProfile.description',
  },
  {
    id: 'clear-charging-profile',
    group: 'smartCharging',
    icon: <Trash2 className="h-4 w-4" />,
    labelKey: 'deviceControl.commands.clearChargingProfile.label',
    descriptionKey: 'deviceControl.commands.clearChargingProfile.description',
  },
];

export const DEFAULT_COMMAND_ID: CommandDefinition['id'] = 'remote-start';
